import React from 'react';
import styled from 'styled-components';

export default function Header() {
  return (
    <Container>
      <h3 className='accessibility_header-title'>Accessibility</h3>
    </Container>
  );
}

const Container = styled.div`
  background-color: #00963b;
  h3 {
    color: white;
    padding: 20px 30px;
    margin: 0rem;
    text-align: center;
    font-family: "Montserrat";
    a {
      text-decoration : none;
      color: white;
    }
  }
  
`;
